var render, staticRenderFns
import script from "./LbaMovable.vue?vue&type=script&lang=js"
export * from "./LbaMovable.vue?vue&type=script&lang=js"
import style0 from "./LbaMovable.vue?vue&type=style&index=0&id=19601660&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports